import { GREATER_THAN } from 'common/constants/messages/validations';
import { RANGE_SENSITIVITY_SPREADSHEET_SENSITIVITY_PCT } from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getNumberValue, getObjectValue } from 'utilities';
import type { CustomValidationsPctParams } from './types';

const customValidationsPct = (params: CustomValidationsPctParams) => {
  const { cell, addFeedbackFromCell, removeFeedbackFromCell } = params;
  const { alias, columnLegend } = getObjectValue(cell);

  if (alias === RANGE_SENSITIVITY_SPREADSHEET_SENSITIVITY_PCT && columnLegend === 'A' && cell) {
    const raw = getNumberValue(cell.value as number | string | null | undefined);
    const feedback = GREATER_THAN(0);

    if (raw <= 0) {
      addFeedbackFromCell?.(cell, feedback);
      return;
    }
    removeFeedbackFromCell?.(cell, feedback);
  }
};

export default customValidationsPct;
